/// <reference path="../_references.ts"/>

module App.WorkOrder {
	import Package = App.PriceGuide.Package;
	import ProductService = App.PriceGuide.ProductService;
	import ServiceRequest = App.Appointments.ServiceRequest;

	export class PackageActionsService {
		protected appointmentId: number;
		public priceCardsVisible: boolean = false;
		public packageCheckboxesVisible: boolean = false;
		public selectForAction: string = '';
		public selectedPackages: Package[] = [];
		private updateAllCallback: Function;

		constructor(
			public ProductService: ProductService,
			public $q: ng.IQService,
		) { }

		public setActiveAppointmentId(id: number) {
			if (this.appointmentId !== id) {
				this.priceCardsVisible = false;
				this.resetSelections();
			}

			this.appointmentId = id;
		}

		public togglePriceCardsVisible() {
			const vm = this;
			vm.priceCardsVisible = !vm.priceCardsVisible;
		}

		private deletePackages(sr: ServiceRequest) {
			const vm = this,
				packages = this.selectedPackages.slice(),
				promises: {[key: number] : ng.IHttpPromise<Package>} = {};

			packages.forEach((pkg) =>{
				promises[pkg.id] = vm.ProductService.deletePackage(sr.id, pkg.id);
			});

			vm.$q.all(promises).then(()=>{
				vm.updateAllCallback();
				vm.resetSelections();
			}, (error) => {
				console.log('Something went wrong - unable to delete all the packages.' + error);
			});
		}

		public resetSelections() {
			const vm = this;
			vm.packageCheckboxesVisible = false;
			vm.selectedPackages = [];
			vm.selectForAction = '';
		}

		private recommendPackages(sr: ServiceRequest) {
			const vm = this,
				packages = this.selectedPackages.slice(),
				promises: {[key: number] : ng.IHttpPromise<Package>} = {};

			packages.forEach((pkg) =>{
				if (!pkg.name) {
					pkg.name = 'Option ' + (pkg.index + 1);
				}

				promises[pkg.id] = vm.ProductService.recommendPackage(sr.id, pkg.id, { name: pkg.name });
			});

			vm.$q.all(promises).then(() => {
				vm.updateAllCallback();
				vm.resetSelections();
			}, (error) => {
				console.log('Something went wrong - unable to recommend all the packages.' + error);
			});
		}

		public makeAction(actionType: string, sr: ServiceRequest, cancel?: boolean) {
			const vm = this,
				doAction = function(type: string) {
					if(type === 'recommend') {
						vm.recommendPackages(sr);
					} else if(type === 'delete') {
						vm.deletePackages(sr);
					}
				},
				getMode = function(actionType: string) {
					let mode = 'select',
						selected = vm.selectedPackages.length > 0;

					if(vm.packageCheckboxesVisible) {
						if(selected) {
							if(actionType == vm.selectForAction) {
								mode = 'action';
							} else {
								mode = 'cancel';
							}
						} else {
							mode = 'cancel';
						}
					}

					return mode;
				};

			if (cancel) {
				vm.resetSelections();
				return;
			}

			switch (getMode(actionType)) {
				case 'cancel' :
					vm.resetSelections();
					break;
				case 'action':
					doAction(actionType);
					break;
				default:
					vm.selectForAction = actionType;
					vm.packageCheckboxesVisible = true;
			}
		}

		public subscribeCallback(callback: Function) {
			const vm = this;

			vm.updateAllCallback = callback;
		}

		public unsubscribeCallback(callback: Function) {
			const vm = this;

			vm.updateAllCallback = null;

		}

		public selectPackage(selectedPkg:Package) {
			const vm = this,
				indexOfPackage = vm.selectedPackages.findIndex((pkg) => {
					return pkg.id === selectedPkg.id;
				});

			if(indexOfPackage > -1) {
				vm.selectedPackages.splice(indexOfPackage, 1);
			} else {
				vm.selectedPackages.push(selectedPkg);
			}

		}

		public isPackageSelected(selectedPkg: Package): boolean {
			const vm = this;
			return vm.selectedPackages.findIndex((pkg) => {
				return pkg.id === selectedPkg.id;
			}) > -1;
		}

		public static Factory() {
			let instance = (ProductService: ProductService, $q: ng.IQService) => {
				return new PackageActionsService(ProductService, $q);
			};

			instance.$inject = ['ProductService', '$q'];

			return instance;
		}
	}
}
